
import React from 'react';
import LoadingIndicator from '../../../common/LoadingIndicator';
import WorkflowExecutionsTable from './WorkflowExecutionsTable';
import NoResultsText from '../../../common/NoResultsText';

interface Props {
  familyId: string;
  executions: any[];
}

function WorkflowExecutionsTab(props: Props) {
  const { executions, familyId } = props;
  const [page, setPage] = React.useState(0);

  function onPageChange(newPage: number) {
    setPage(newPage);
  }

  if (executions) {
    return (
      <div>
        {executions.length > 0 && <WorkflowExecutionsTable
          familyId={familyId}
          executions={executions}
          page={page}
          onPageChange={onPageChange}
        />}
        {executions.length === 0 && <NoResultsText>No executions for this workflow</NoResultsText>}
      </div>
    );
  } else {
    return <LoadingIndicator loading={true} />;
  }
};

export default WorkflowExecutionsTab;
